export default __webpack_public_path__ + "static/media/currency.6ea3d73d.svg";